import { createSlice } from '@reduxjs/toolkit';

// Initial state
const initialState = {
  error: null,
  columns: [],
  filters: {},
  fields: [],
  selectedColumns: [],
};

// Redux slice
const companyReportsSlice = createSlice({
  name: 'companyReports',
  initialState,
  reducers: {
    setSelectedColumns: (state, action) => {
      state.selectedColumns = action.payload;
    },
    setFields: (state, action) => {
      state.fields = action.payload;
    },
    setColumns: (state, action) => {
      state.columns = action.payload;
    },
    updateFields: (state, action) => {
      state.fields = action.payload;
    },
    updateFilters: (state, action) => {
      state.filters = {
        ...state.filters,
        ...action.payload, // Merge new filters with existing ones
      };
    },
    resetFilters: (state) => {
      state.filters = {}; // Reset filters
    },
  },
});

export const {
  updateFilters,
  resetFilters,
  updateFields,
  setFields,
  setSelectedColumns,
  setColumns,
} = companyReportsSlice.actions;

export default companyReportsSlice.reducer;
